/* eslint-disable @nx/enforce-module-boundaries */
import React, { useState, useEffect, useRef, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CreatableSelect from 'react-select/creatable';
import { Card, CardBody } from '@mybridge/ui/card';
import { Button } from '@mybridge/ui/button';
import EditorConvertToHTML, {
  NormalizedEditorConvertToHTML,
} from 'v4/components/common/Editor';
import { HStack, Text, VStack } from '@mybridge/ui';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
} from '@mybridge/ui/form-control';

import {
  postNewJob,
  UpdateJob,
  getCompanyAllJobs,
  getJobSubscriptionDetails,
  checkCompanyJobFreeSlot,
  UpdatePartialJob,
} from 'v4/store/actions/companyJobs.actions';
import { get, upperCase } from 'lodash';
import { useToast } from '@mybridge/ui';
import _ from 'lodash';
import { Tag, TagCloseButton, TagLabel, Box } from '@mybridge/ui';
import { useRouter } from 'next/router';
import { getGlobalSkills } from 'v4/store/actions/global.data.actions';

import { clearUpdateJobDetails } from 'v4/store/actions/Job.Action';
import { Controller, useForm } from 'react-hook-form';
import { CreateJobsContext } from 'v4/components/company/Layout/context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';

// Add the helper function here
const getApiMessage = (response, fallbackMessage) => {
  
  // Try different possible message fields from the API response
  const possibleMessageFields = [
    'payload.message',
    'payload.detail', 
    'payload.success_message',
    'payload.msg',
    'payload.notification',
    'message',
    'detail',
    'success_message'
  ];
  
  for (const field of possibleMessageFields) {
    const message = get(response, field);
    if (message && typeof message === 'string') {
      return message;
    }
  }
  
  return fallbackMessage;
};

const RoleSection = () => {
  const dispatch = useDispatch();
  const { formatNumber } = useNumberFormatter();
  const maxChar = 2000;
  const ref = useRef();
  const router = useRouter();
  const { editDetails, isRepost } = useSelector((state) => state.jobsReducer);
  const { companyJobList, userJobSubscription, freeSlotAvailable } =
    useSelector((state) => state.companyJobs);

  const {
    setSelectCompany,
    toast,
    createOrUpdateJob,
    createJobLoading,
    updateJobLoading,
    isEdit,
    setSection,
    jobDetails,
    setJobDetails,
    screeningQuestions: questions,
    setWindowMaximise,
    windowMaximise,
  } = useContext(CreateJobsContext);
  const { t } = useTranslator();
  const [toolbarOptions] = useState(['inline', 'list', 'textAlign']);
  const [skills, setSkills] = useState([]);
  const [paymentModal, setPaymentModal] = useState(false);
  const [jobPostedSuccess, setJobPostedSuccess] = useState(false);
  const [jobDescription, setJobDescription] = useState();
  const [currentSubscription, setCurrentSubscription] = useState();
  const [maxSlotAllowed, setMaxSlotAllowed] = useState(null);
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const { companyPage } = useSelector((state) => state);
  const {
    companyPageDetail,
  } = companyPage;

  useEffect(() => {
    dispatch(getCompanyAllJobs(jobDetails?.hiring_company));
    dispatch(getJobSubscriptionDetails());
    dispatch(checkCompanyJobFreeSlot(jobDetails?.hiring_company));
    // eslint-disable-next-line
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm();


  const descWatch = watch('job_description');

  const setDataValue = (name, data) => {
    setJobDetails((state) => ({
      ...state,
      [name]: data.name,
    }));
  };

  useEffect(() => {
    const jobSlotsDetails = _.find(userJobSubscription?.results, function (o) {
      return o.company_page == jobDetails?.hiring_company;
    });

    setCurrentSubscription(jobSlotsDetails);
    setMaxSlotAllowed(
      jobSlotsDetails?.job_slots
        ? jobSlotsDetails?.job_slots.total - jobSlotsDetails?.job_slots.used
        : 0
    );
  }, [userJobSubscription]);

  const onClickBack = (e) => {
    e.preventDefault();
    setSection(3);
  };
  useEffect(() => {
    if (jobDetails?.job_description) {
      setValue('job_description', jobDetails?.job_description);
    }
  }, [jobDetails]);

  const isEmptyHtml = (html) => {
    // Remove all HTML tags and trim whitespace
    const text = (html ?? '').replace(/<[^>]*>/g, '').trim();
    return text.length === 0;
  };

  // console.log('freeSlotAvailable', freeSlotAvailable);
  // console.log('maxSlotAllowed', maxSlotAllowed);
  // console.log('userSubscription', currentSubscription);
  // console.log('editDetails', editDetails);

  const savePostJobs = (isDraft) => {
    // debugger
    // Check if form is valid before proceeding
    if (!isDraft && (isEmptyHtml(getValues('job_description')))) {
      // Set error manually if needed
      setValue('job_description', '', { shouldValidate: true });
      // Trigger validation to show error message
      handleSubmit(() => {})();
      return;
    }

    const payload = {
      body: {
        job_description: jobDetails?.job_description,
        is_draft:
          !freeSlotAvailable && maxSlotAllowed < 1 ? true : Boolean(isDraft),
        is_published:
          !freeSlotAvailable && maxSlotAllowed === 0
            ? false
            : Boolean(!isDraft),
      },
      id: jobDetails?.id,
      method: 'PUT',
    };
    setWindowMaximise(false);
    
    if (jobDetails?.id && typeof window !== 'undefined') {
      try {
        localStorage.setItem('recentSavedJob', JSON.stringify({
          ...jobDetails,
          job_description: jobDetails?.job_description,
          lastSaved: new Date().toISOString()
        }));
      } catch (e) {
        localStorage.setItem('recentSavedJob', JSON.stringify({id:jobDetails?.id}));
        console.error('Error saving job details to localStorage', e);
      }
    }

    if (!freeSlotAvailable && maxSlotAllowed < 1 && isDraft == false) {
      // console.log(payload);
      setPaymentModal(true);
      dispatch(UpdatePartialJob(payload));
      router.push(`/page/jobs/subscription/${jobDetails?.hiring_company}`);
    } else {
      dispatch(UpdatePartialJob(payload)).then((res) => {
        const jobId = get(res, 'payload.id');
        
        // Check if there's an error in the response
        if (res?.payload?.status_code >= 400 || res?.error) {
          const errorMessage = getApiMessage(res, 'An error occurred while processing your request');
          toast({
            title: errorMessage,
            status: 'error',
            isClosable: true,
            position: 'top',
            duration: 9000,
          });
          return;
        }
        
        if (jobId) {
          // Check job_status from API response to determine the correct message
          const jobStatus = get(res, 'payload.job_status');

          
          let fallbackMessage;
          if (jobStatus === 'draft') {
            fallbackMessage = t('createJob.saveJobSuccess') || 'Job Saved Successfully';
          } else {
            fallbackMessage = t('createJob.postJobSuccess') || 'Job Posted Successfully';
          }
          
          const dynamicMessage = getApiMessage(res, fallbackMessage);
          
          toast({
            title: dynamicMessage,
            status: 'success',
            isClosable: true,
            position: 'top',
            duration: 9000,
          });
          trackEvent(ANALYTICS_EVENTS.CreateJob, userProfileInfo?.slug || 'anonymous', {
            companySlug: companyPageDetail?.slug || 'anonymous'
          });
          router.push(`/page/private/${jobDetails?.hiring_company}/jobs`);
          setJobDetails();
          setSkills([]);
          setJobPostedSuccess(true);
          dispatch(clearUpdateJobDetails());
          setSection(1);
          // setTimeout(function () {
          // }, 5000);
        }
      });
    }
  };

  const updateJobDetails = (message) => {
    // Check if form is valid before proceeding
    if (!message && (isEmptyHtml(getValues('job_description')))) {
      // Set error manually if needed
      setValue('job_description', '', { shouldValidate: true });
      // Trigger validation to show error message
      handleSubmit(() => {})();
      return;
    }

    const payload = {
      body: {
        job_description: jobDetails?.job_description,
      },
      id: jobDetails?.id,
      method: 'PUT',
    };
    setWindowMaximise(false);
    dispatch(UpdatePartialJob(payload)).then((res) => {
      const jobId = get(res, 'payload.id');
      if (jobId) {
        setJobDetails();
        setSkills([]);
        setJobPostedSuccess(true);
        dispatch(clearUpdateJobDetails());
        setSection(1);
        toast({
          title: message
            ? t('createJob.saveJobSuccess') || 'Job Saved Successfully'
            : t('createJob.updateJobSuccess') || 'Job Updated Successfully',
          status: 'success',
          isClosable: true,
          position: 'top',
          duration: 9000,
        });
        setTimeout(function () {
          router.push(`/page/private/${jobDetails?.hiring_company}/jobs`);
        }, 5000);
      }
    });
  };
  // Calculate current character count for better readability
const currentCharCount = descWatch && !isEmptyHtml(descWatch) ? 
  descWatch.replace(/<[^>]*>/g, '').trim().length : 0;



  useEffect(() => {
    if (jobPostedSuccess) {
      localStorage.removeItem('recentJob');
    }
  }, [jobPostedSuccess]);

  useEffect(() => {
    if (descWatch && descWatch?.length && descWatch?.length > 0) {
      setJobDetails({
        ...jobDetails,
        job_description: descWatch,
      });
    }
  }, [descWatch]);



  return (
    <>
      <Box mb={3} w="100%">
        <FormControl isInvalid={errors.job_description}>
          <FormLabel
            mb={0}
            fontSize="sm"
            color="brandGray.30"
            fontWeight="medium"
            htmlFor="job_description"
          >
            {t('jobs.jobDescription') || "Job Description"}*
          </FormLabel>
          {/* <Text color="#868585">Job Description*</Text> */}

          <Controller
            {...register('job_description', {
              required: true,
            })}
            control={control}
            render={({ field }) => (
              <NormalizedEditorConvertToHTML
                toolbarOptions={['inline', 'list']}
                toolbardropDown={false}
                toolbarItemOptions={{
                  inline: {
                    options: ['bold', 'italic', 'underline'],
                  },
                }}
                name="job_description"
                editorClass={errors.job_description ? 'job-textarea error-border' : 'job-textarea'}
                {...field}
                isInvalid={!!errors.job_description}
              />
            )}
          ></Controller>
          <HStack>
            <Box flex={1}>
            {currentCharCount >= maxChar && (
                <Text fontSize="xs" color="red">
                  {t('createJob.maxCharactersAllowed') || "Max 2000 characters allowed"}
                </Text>
              )}
            </Box>
            <Text>
            {formatNumber(currentCharCount)}/{formatNumber(maxChar)}
            </Text>
          </HStack>
          {errors.job_description && (
            <FormErrorMessage mt={0}>
              {t('createJob.jobDescriptionMandatory') || "Job Description is mandatory"}
            </FormErrorMessage>
          )}
        </FormControl>
      </Box>

      <VStack align="stretch" alignItems="space-between" w="100%">
        <Box
          display="flex"
          justifyContent={windowMaximise ? 'flex-end' : 'flex-start'}
        >
          {!isEdit ? (
            <Button
              w={windowMaximise ? '20%' : '50%'}
              variant="secondary"
              borderRadius="full"
              me={3}
              onClick={onClickBack}
            >
              {t('buttons.back') || "Back"}
            </Button>
          ) : (
            <Button
              w={windowMaximise ? '20%' : '50%'}
              variant="secondary"
              borderRadius="full"
              me={3}
              onClick={() => router.back()}
            >
              {t('buttons.cancel') || "Cancel"}
            </Button>
          )}

          {editDetails && !isRepost ? (
            editDetails && !editDetails?.is_draft ? (
              <Button
                w={windowMaximise ? '20%' : '45%'}
                variant="primary"
                borderRadius="full"
                onClick={() => updateJobDetails()}
              >
                {t('createJob.saveJob') || "Save Job"}
              </Button>
            ) : (
              <Button
                w={windowMaximise ? '20%' : '45%'}
                variant="primary"
                borderRadius="full"
                onClick={() => savePostJobs(false)}
              >
                {t('createJob.saveAndPublish') || "Save & Publish"}
              </Button>
            )
          ) : (
            <Button
              w={windowMaximise ? '20%' : '45%'}
              variant="primary"
              borderRadius="full"
              onClick={() => savePostJobs(false)}
            >
              {t('createJob.publish') || "Publish"}
            </Button>
          )}
        </Box>
        <Box
          fontSize="12px"
          display="flex"
          justifyContent={windowMaximise ? 'flex-end' : 'flex-start'}
          marginRight={windowMaximise ?? '9%'}
        >
          {t('createJob.needToFinishLater') || "Need to finish up later?"} {' '}
          <Box
            as="span"
            onClick={() => updateJobDetails(true)}
            cursor="pointer"
          >
            {t('createJob.saveAsDraft') || "Save as draft"}
          </Box>
        </Box>
      </VStack>

      {/* {paymentModal && <JobSubscriptionPage jobDetails={jobDetails} />} */}
    </>
  );
};

export default RoleSection;
